import React from 'react';

const StrategicConsulting = () => {
  return (
    <div className="content-section">
      <div className="container mx-auto px-4">
        <div className="glass-card rounded-lg p-8 md:p-12">
          <h1 className="text-4xl font-bold text-primary mb-6 text-center">
            Strategic Consulting and Management
          </h1>
          <div className="w-24 h-1 bg-gold mx-auto mb-8"></div>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <p className="text-lg text-gray-700 leading-relaxed text-center mb-8">
              Vajreya Ventures provides comprehensive strategic consulting and management services, helping businesses achieve operational excellence and strategic growth through expert advisory and tailored solutions.
            </p>

            <h2 className="text-2xl font-bold text-primary mb-4">Our Consulting Services</h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Strategic Planning</h3>
                <p className="text-gray-700">
                  We help organizations develop comprehensive strategic plans that align with their vision, mission, and business objectives, ensuring sustainable growth and competitive advantage.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Business Advisory</h3>
                <p className="text-gray-700">
                  Our expert advisors provide insights and recommendations on business operations, organizational structure, market positioning, and growth strategies tailored to your industry.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Management Training</h3>
                <p className="text-gray-700">
                  Specialized training programs for management teams, covering leadership development, operational efficiency, financial management, and industry-specific best practices.
                </p>
              </div>

              <div className="bg-white border-2 gold-border rounded-lg p-6">
                <h3 className="text-xl font-bold text-primary mb-3">Performance Optimization</h3>
                <p className="text-gray-700">
                  Analyze and optimize business processes, implement efficiency improvements, and develop metrics to measure and enhance organizational performance across all departments.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg p-8 text-center">
              <h3 className="text-2xl font-bold mb-4">Transform Your Business Strategy</h3>
              <p className="mb-6">
                Partner with Vajreya Ventures for expert consulting services that drive measurable results and sustainable growth.
              </p>
              <a 
                href="/contact" 
                className="inline-block px-8 py-3 bg-gold text-white font-semibold rounded-lg hover:bg-gold-dark transition-colors shadow-lg"
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategicConsulting;